import React from 'react'
import './App.css'
import { useDispatch, useSelector } from 'react-redux'
import { selectAllTheme, toggleTheme } from './features/ModeSlice'
import Todos from './features/Todos'



const App = () => {
  const theme=useSelector(selectAllTheme)
  const dispatch=useDispatch()
  const Style={
    
    background:theme?'#e6e6e6':"#FB9902",
    color:theme?"black":"white",
    
    
  }

  return (
   <>
    <div style={Style} className='appHeader'>
      <button className="btn btn-primary m-5" onClick={()=>dispatch(toggleTheme())}>Dark</button>
        <Todos/>
    </div>
   </>
  )
}

export default App
